import { defineStore } from 'pinia';
import AuthService from '../services/auth.service';

let initAuthPromise = null;

export const useAuthStore = defineStore('auth', {
    state: () => ({
        loggedIn: false,
        user: null,
        initialized: false,
        twoFactorRequired: false,
        twoFactorEmail: '',
        twoFactorDeliveryChannel: '',
    }),
    actions: {
        async initAuth() {
            if (this.initialized) {
                return;
            }

            if (!initAuthPromise) {
                initAuthPromise = (async () => {
                    try {
                        const user = await AuthService.me();
                        this.loggedIn = user.user !== null;
                        this.user = user;
                    } catch (error) {
                        this.loggedIn = false;
                        this.user = null;
                    } finally {
                        this.initialized = true;
                    }
                })();
            }

            await initAuthPromise;
        },
        login(user) {
            return AuthService.login(user).then(
                (userData) => {
                    if (userData?.two_factor_required) {
                        this.loggedIn = false;
                        this.user = null;
                        this.twoFactorRequired = true;
                        this.twoFactorEmail = userData.email || '';
                        this.twoFactorDeliveryChannel = userData.delivery_channel || 'email';

                        return Promise.resolve(userData);
                    }

                    this.loggedIn = true;
                    this.user = userData;
                    this.twoFactorRequired = false;
                    this.twoFactorEmail = '';
                    this.twoFactorDeliveryChannel = '';

                    return Promise.resolve(userData);
                },
                (error) => {
                    this.loggedIn = false;
                    this.user = null;
                    this.twoFactorRequired = false;
                    this.twoFactorEmail = '';
                    this.twoFactorDeliveryChannel = '';

                    return Promise.reject(error);
                }
            );
        },
        confirmTwoFactorLogin(code) {
            return AuthService.confirmTwoFactorLogin(code).then(
                (userData) => {
                    this.loggedIn = true;
                    this.user = userData;
                    this.twoFactorRequired = false;
                    this.twoFactorEmail = '';
                    this.twoFactorDeliveryChannel = '';

                    return Promise.resolve(userData);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        resendTwoFactorLoginCode() {
            return AuthService.resendTwoFactorLoginCode().then(
                (responseData) => {
                    this.twoFactorEmail = responseData.email || this.twoFactorEmail;
                    this.twoFactorDeliveryChannel = responseData.delivery_channel || this.twoFactorDeliveryChannel;

                    return Promise.resolve(responseData);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },
        async logout() {
            await AuthService.logout();
            this.loggedIn = false;
            this.user = null;
            this.initialized = true;
            this.twoFactorRequired = false;
            this.twoFactorEmail = '';
            this.twoFactorDeliveryChannel = '';
        },
        register(user) {
            return AuthService.register(user).then(
                (responseData) => {
                    this.loggedIn = false;
                    return Promise.resolve(responseData);
                },
                (error) => {
                    this.loggedIn = false;
                    return Promise.reject(error);
                }
            );
        },
    },
});